export default {
  Loading: {
    en: 'Loading',
    ru: 'Загрузка',
    ja: '読み込み中'
  },
  ConnectWallet: {
    en: 'Connect Wallet',
    ru: 'Подключить кошелек',
    ja: 'ウォレットを接続する'
  },
  Available: {
    en: 'Available',
    ru: 'Доступно',
    ja: '利用可能'
  }
}